// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* min-height: 100vh; Optional: centers vertically on page */
  }

.description-container {
    text-align: center;
    padding: 2rem;
    max-width: 800px;
  }
  
.title {
    margin-bottom: 1rem;
    font-size: 2rem;
    color: #333; /* Dark gray */
  }
  
.subtitle {
    font-size: 1.2rem;
    color: #666; /* Medium gray */
    line-height: 1.5;
  }`, "",{"version":3,"sources":["webpack://./src/dashboard/pages/Frontpage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,4DAA4D;EAC9D;;AAEF;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;AAEF;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW,EAAE,cAAc;EAC7B;;AAEF;IACI,iBAAiB;IACjB,WAAW,EAAE,gBAAgB;IAC7B,gBAAgB;EAClB","sourcesContent":[".center {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    /* min-height: 100vh; Optional: centers vertically on page */\n  }\n\n.description-container {\n    text-align: center;\n    padding: 2rem;\n    max-width: 800px;\n  }\n  \n.title {\n    margin-bottom: 1rem;\n    font-size: 2rem;\n    color: #333; /* Dark gray */\n  }\n  \n.subtitle {\n    font-size: 1.2rem;\n    color: #666; /* Medium gray */\n    line-height: 1.5;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
